import { render, staticRenderFns } from "./DLGPrint.vue?vue&type=template&id=349cd928&"
import script from "./DLGPrint.vue?vue&type=script&lang=js&"
export * from "./DLGPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('349cd928')) {
      api.createRecord('349cd928', component.options)
    } else {
      api.reload('349cd928', component.options)
    }
    module.hot.accept("./DLGPrint.vue?vue&type=template&id=349cd928&", function () {
      api.rerender('349cd928', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/ticket2/ticketPublish/DLGPrint.vue"
export default component.exports